<template>
  <div>
    <div class="card-header p-b-10">
      <h2 class="c-black">{{ $t('Active Projects') }}</h2>
    </div>
    <div class="card-body card-padding-sm">
      <div>
        <!-- Loading -->
        <div v-if="$apollo?.loading">
          <ProjectsCardItemSkeleton />
          <ProjectsCardItemSkeleton />
          <ProjectsCardItemSkeleton />
        </div>

        <!-- Error -->
        <div v-else-if="$apollo?.error">
          {{ $t('An error occurred while loading your projects.') }}
        </div>

        <!-- Result -->
        <BaseShowMore v-else-if="$apollo?.data" :collapsed-height="600">
          <template v-if="projects.data.length === 0">
            <div class="m-l-15 m-r-15">
              <WdsText>
                {{ $t('You currently have no active projects in Worksome.') }}
                <a :href="createProjectRoute">{{ $t('Create a new project') }}</a>
              </WdsText>
            </div>
          </template>

          <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
          <list-animation>
            <ProjectsCardItem
              v-for="project in projects.data"
              :id="project.id"
              :key="project.id"
              :title="project.name"
              :description="project.description"
              :budget="project.internalBudget"
              :spent="project.spent"
              :allocated="project.allocatedBudget"
              :currency="project.currency"
            />
          </list-animation>

          <div v-if="projects.paginatorInfo.hasMorePages" class="m-5 text-right">
            <a :href="projectsRoute">
              {{ $t('See all your projects') }}
            </a>
          </div>
          <template #button="{ buttonText }">
            <BaseShowMoreButton class="m-l-10" :button-text="buttonText" />
          </template>
        </BaseShowMore>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { WdsText } from '@worksome/wds-components'
import BaseShowMore from '@/components/BaseShowMore.vue'
import BaseShowMoreButton from '@/components/BaseShowMoreButton.vue'
import ProjectsCardItem from '@/components/Projects/ProjectsCardItem.vue'
import ProjectsCardItemSkeleton from '@/components/Projects/ProjectsCardItemSkeleton.vue'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'

export default {
  components: {
    ProjectsCardItem,
    ProjectsCardItemSkeleton,
    BaseShowMore,
    BaseShowMoreButton,
    WdsText,
  },
  apollo: {
    $client: 'publicApi',
    projects: {
      query: gql`
        query Projects($accounts: [ID!], $status: [ProjectStatusFilter!]) {
          projects(accounts: $accounts, status: $status, first: 25) {
            paginatorInfo {
              hasMorePages
            }
            data {
              id
              name
              description
              internalBudget
              spent
              allocatedBudget
              currency
            }
          }
        }
      `,
      variables() {
        return {
          accounts: [this.account.globalId],
          status: ['OPEN'],
        }
      },
    },
  },
  computed: {
    projectsRoute() {
      return laravelNamedRoute(namedRoutes.projects.index)
    },
    createProjectRoute() {
      return `${this.projectsRoute}?createProject`
    },
  },
}
</script>
